import './NewsletterFormComingSoon.scss';

import { b2x } from '@b2x/react/src';
import React from 'react';

import { Container } from './Container';
import { t } from './i18n/i18n';

// eslint-disable-next-line @typescript-eslint/ban-types
type AdditionalPropertiesFormValues = {};

// eslint-disable-next-line @typescript-eslint/ban-types
type AdditionalPropertiesValidationSchema = b2x.yup.ObjectSchema<{}>;

export type NewsletterFormComingSoonProps = Omit<
  b2x.NewsletterFormProps<AdditionalPropertiesFormValues, AdditionalPropertiesValidationSchema>,
  | 'additionalPropertiesInitialValues'
  | 'additionalProperties'
  | 'additionalPropertiesValidationSchema'
  | 'validationSchemaSelector'
>;

export const NewsletterFormComingSoon = ({
  ctaContainerClassName,
  emailFieldStyle = 'textInput',
  onSuccess,
  redirectToHomeOnSuccessModalClose,
  ...otherProps
}: NewsletterFormComingSoonProps) => {
  const { showModal } = b2x.useModals();
  const navigate = b2x.router.useNavigate();

  const onSuccessCallback = React.useCallback(() => {
    onSuccess && onSuccess();
    b2x.storage.setBoolean('newsletterConsent', true, true);
    showModal({
      buttons: [
        {
          close: true,
          label: t('form.newsletterForm.outcome.success.buttons.ok.label'),
        },
      ],
      children: t('form.newsletterForm.outcome.success.body'),
      className: 'modal-newsletter-form',
      onClose: () => {
        if (redirectToHomeOnSuccessModalClose) {
          navigate('/');
        }
      },
      title: t('form.newsletterForm.outcome.success.title'),
    });
  }, [navigate, onSuccess, redirectToHomeOnSuccessModalClose, showModal]);

  return (
    <Container className="newsletter-form-coming-soon">
      <b2x.Row justifyContent={'center'}>
        <b2x.Col size={{ sm: 12 }}>
          <div aria-label="Newsletter form" className="mt-3" role="region">
            <b2x.NewsletterFormHelper<AdditionalPropertiesFormValues, AdditionalPropertiesValidationSchema>
              {...otherProps}
              emailFieldStyle={emailFieldStyle}
              onSuccess={onSuccessCallback}
              redirectToHomeOnSuccessModalClose
              validationSchemaSelector={{ name: false, surname: false }}
            >
              {({ fieldsHelper, formik }) => (
                <>
                  <div className="d-flex">
                    {emailFieldStyle === 'inputGroup' && (
                      <b2x.FormGroup {...fieldsHelper.email.formGroup} className="col" label={undefined}>
                        <b2x.InputGroup {...fieldsHelper.email.inputGroup}>
                          <b2x.TextInput className="me-3" {...fieldsHelper.email.textInput} />
                        </b2x.InputGroup>
                      </b2x.FormGroup>
                    )}
                    {emailFieldStyle === 'textInput' && (
                      <b2x.FormGroup {...fieldsHelper.email.formGroup} className="col" label={undefined}>
                        <b2x.TextInput {...fieldsHelper.email.textInput} />
                      </b2x.FormGroup>
                    )}
                    <div className="col-auto">
                      <b2x.Button
                        {...fieldsHelper.buttons.submit}
                        label={t('form.newsletterForm.buttons.submit.label')}
                        variant="secondary"
                      />
                    </div>
                  </div>
                  <fieldset>
                    <legend className="visually-hidden">{fieldsHelper.consents.legend}</legend>
                    <b2x.FormGroup {...fieldsHelper.consents.newsletterConsent.formGroup} label={undefined}>
                      <b2x.Checkbox
                        {...fieldsHelper.consents.newsletterConsent.checkbox}
                        labelClassName="extra-small text-start text-white"
                      />
                    </b2x.FormGroup>
                  </fieldset>
                </>
              )}
            </b2x.NewsletterFormHelper>
          </div>
        </b2x.Col>
      </b2x.Row>
    </Container>
  );
};
